module.exports = "../dist/img/white-22.2dff.jpg";